import { render, staticRenderFns } from "./CheckoutNav.vue?vue&type=template&id=5b1305fe&"
import script from "./CheckoutNav.vue?vue&type=script&lang=js&"
export * from "./CheckoutNav.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports